module.exports = __webpack_public_path__ + "static/img/startripx.ef1f249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/startripx.png
// module id = 4Bkm
// module chunks = 1